module.exports = __webpack_public_path__ + "static/img/bg_4_2_3.9fa3e29.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg_4_2_3.png
// module id = w1x7
// module chunks = 3